import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";


@Injectable({
    providedIn: 'root'
})
export class ApiServerService {

    //Este servicio se es para las llamadas a nuestro back
    headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('ET_EMYRtokenApi')}`
    });
    headersFile = new HttpHeaders({
        //'Content-Type': 'undefined',
        'Authorization': `Bearer ${localStorage.getItem('ET_EMYRtokenApi')}`
    });
    constructor(private http: HttpClient) {
    }



    newComentario(data: any) {
        return this.http.post(`${environment.urlBack}/detail/comments`, data, { headers: this.headers }).pipe(
            map((isAlive: any) => {
                return isAlive;
            })
        );
    }
    getComentario(id: any) {
        return this.http.get(`${environment.urlBack}/detail/comments/${id}`, { headers: this.headers }).pipe(
            map((isAlive: any) => {
                return isAlive;
            })
        );
    }
    getComentarios(nro: any) {
        return this.http.get(`${environment.urlBack}/detail/comments/ot/${nro}`, { headers: this.headers }).pipe(
            map((isAlive: any) => {
                return isAlive;
            })
        );
    }
    getDetail(data: any) {
        return this.http.post(`${environment.urlBack}/detail`, data, { headers: this.headers }).pipe(
            map((isAlive: any) => {
                return isAlive;
            })
        );
    }
    getDetailComplete(data: any) {
        return this.http.post(`${environment.urlBack}/complete`, data, { headers: this.headers }).pipe(
            map((isAlive: any) => {
                return isAlive;
            })
        );
    }
    getPuntajes() {
        return this.http.get(`${environment.urlBack}/protocols/get-all`, { headers: this.headers }).pipe(
            map((isAlive: any) => {
                return isAlive;
            })
        );
    }
    fixEncoding(str: string): string {
        try {
            return decodeURIComponent(escape(str));
        } catch (e) {
            return str;
        }
    }
    updatePuntajes(data: any) {
        return this.http.post(`${environment.urlBack}/protocols/update`, data, { headers: this.headers }).pipe(
            map((isAlive: any) => {
                return isAlive;
            })
        );
    }
}
